export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";
export const API_SOCKET_URL = process.env.REACT_APP_API_SOCKET_URL ?? "";

/** Canonical origin for Kakao / OG share links (falls back to window.location.origin in UI). */
export const PUBLIC_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL?.trim() ?? "";

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL ?? "";
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY ?? "";

export const isDev = process.env.NODE_ENV === "development";
export const REACT_APP_NOTIFICATION_VAPID_KEY = process.env.REACT_APP_NOTIFICATION_VAPID_KEY || "";
